export interface CaptchaService {
  /**
   * Проверяет токен каптчи на валидность. Если не проходит проверку, выбрасывает исключение.
   *
   * @throws CaptchaNotValidError если проверка не пройдена
   * */
  verify(token: string): Promise<void>
}

export class CaptchaNotValidError extends Error {}
